import { font } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import styled from 'styled-components';

export interface HeaderBannerProps {
  readonly text: string;
  readonly href?: string;
  readonly backgroundColor?: string;
  readonly textColor?: string;
}

const BannerContainer = styled.div<{ $backgroundColor: string; $textColor: string }>`
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  color: ${({ $textColor }) => $textColor};
  text-align: center;
  padding-block: 5px;
  ${font('main', { fontSize: '1.4rem', lineHeight: 1.4 })};
  width: 100%;
  order: 0;

  ${MEDIA_QUERIES.desktop`
    padding-block: 7px; 
  `}
`;

const BannerLink = styled.a<{ $textColor: string }>`
  color: ${({ $textColor }) => $textColor};
  text-decoration: none;
  display: block;
  width: 100%;

  &:hover {
    text-decoration: underline;
  }
`;

const BannerText = styled.span`
  display: block;
`;

export const HeaderBanner: React.FC<HeaderBannerProps> = ({
  text,
  href,
  backgroundColor = '#262626',
  textColor = '#FFFFFF',
}) => {
  const content = href ? (
    <BannerLink href={href} $textColor={textColor}>
      {text}
    </BannerLink>
  ) : (
    <BannerText>{text}</BannerText>
  );

  return (
    <BannerContainer $backgroundColor={backgroundColor} $textColor={textColor}>
      {content}
    </BannerContainer>
  );
};
